import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "24x24/images"
  }, React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0875 0.446715C10.9937 0.292988 9.98232 1.05509 9.82859 2.1489L9.4563 4.7979L11.5202 4.48292L11.8091 2.42725L20.7215 3.67981L19.469 12.5922L16.7738 12.2134L17.3396 16.3323L18.9123 16.5533C20.0061 16.707 21.0174 15.9449 21.1712 14.8511L22.7021 3.95815C22.8558 2.86434 22.0937 1.853 20.9999 1.69927L12.0875 0.446715Z",
    fill: "currentColor"
  }), React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.29776 9.95832C1.14403 8.8645 1.90613 7.85316 2.99995 7.69944L11.9124 6.44688C13.0062 6.29315 14.0175 7.05525 14.1712 8.14907L15.7021 19.042C15.8559 20.1358 15.0938 21.1472 14 21.3009L5.08754 22.5535C3.99372 22.7072 2.98239 21.9451 2.82866 20.8513L1.29776 9.95832ZM5.53717 11.3822C5.61404 11.9291 5.23299 12.4347 4.68608 12.5116C4.13917 12.5885 3.6335 12.2074 3.55664 11.6605C3.47977 11.1136 3.86082 10.6079 4.40773 10.5311C4.95464 10.4542 5.46031 10.8353 5.53717 11.3822ZM13.5824 18.3301L12.7474 12.3885L9.43272 17.0956L7.51112 15.5479L4.67001 19.5826L8.01219 19.1129L8.01217 19.1129L13.5824 18.3301Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Images24 } from '@cian/ui-kit/icons';`, <br />
 * где 24 - это размер иконки в пикселях.
 */

export var Images24 = createIcon(IconComponent);